import React, { Fragment, useState, useEffect } from "react";
import { Col, Row, Card, CardBody, Button, Container, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import MomentUtils from '@date-io/moment';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from 'moment';
import TableRegitersControl from './TableRegitersControl';
import RegistersControlExcel from './RegistersControlExcel';
import TableMontlhyRejecteds from "./TableMontlhyRejecteds";
import AnimatedBarMontlyRejecteds from './AnimatedBarMontlyRejecteds';
import ModalMontlyRejecteds from './ModalMontlyRejecteds';
import classnames from 'classnames';
import CriterialsDescriptions from './CriterialsDescriptions';
import Spinner from 'react-bootstrap/Spinner';

const RegistersControl = ({ }) => {

    const [activeTab, setActiveTab] = useState('1');
    const [starterDate, setStarterDate] = React.useState(null);
    const [finalDate, setFinalDate] = React.useState(null);
    const [dataIndicator, setDataIndicator] = React.useState([]);
    const [dataIndicatorRejects, setDataIndicatorRejects] = React.useState([]);
    const [openModalCompare, setOpenModalCompare] = React.useState(false);
    const [loading, setLoading] = React.useState(true);

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    useEffect(() => {
        allYear();
    }, []);

    const allYear = async () => {
        try {
            let actualYear = new Date().getFullYear();
            let fecha_inicial = moment(`01/01/${actualYear}`, "DD/MM/YYYY").toDate();
            let fecha_final = moment(`31/12/${actualYear}`, "DD/MM/YYYY").toDate();

            setStarterDate(fecha_inicial);
            setFinalDate(fecha_final);

            await getIndicatorRegistersControl(fecha_inicial, fecha_final);
        }
        catch (err) {

        }
    }

    const getIndicatorRegistersControl = async (sDate, eDate) => {
        setLoading(true);
        if (sDate != null && eDate != null) {
            await fetch(process.env.REACT_APP_PUBLIC_URL + 'indicadores/control-registros', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify({
                    fecha_inicio: moment(`${moment(sDate).format('YYYY/MM/DD')} 00:00:00`).format('YYYY-MM-DD HH:mm:ss'),
                    fecha_final: moment(`${moment(eDate).format('YYYY/MM/DD')} 23:59:59`).format('YYYY-MM-DD HH:mm:ss')
                })
            }).then(response => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error('Data');
                }
            }).then(data => {
                setDataIndicator(data.indicador.control_registros);
                setDataIndicatorRejects(data.indicador.vista_mensual);
                setLoading(false);
            }).catch(err => {
                setDataIndicator([]);
                setDataIndicatorRejects([]);
                setLoading(false);
                console.log(err);
            });
        }
        else {
            setLoading(false);
            alert("Debe indicar la Fecha Inicial y la Fecha Final para Filtrar");
        }
    }

    const ExportRegistersControlExcel = () => {
        RegistersControlExcel.exportExcel(dataIndicator);
    }

    return (
        <Fragment>
            <Row>
                <Col md={12}>
                    <div className="card__title">
                        <h5 className="bold-text">Control de Registros</h5>
                    </div>
                </Col>
            </Row>

            <Row>
                <Col md={3}>
                    <MuiPickersUtilsProvider utils={MomentUtils} >
                        <KeyboardDatePicker
                            style={{ minWidth: '300px', maxWidth: '100%' }}
                            value={starterDate}
                            onChange={(date) => {
                                setStarterDate(date);
                            }}
                            label="Fecha Inicial"
                            format="DD/MM/YYYY"
                            animateYearScrolling
                            className='medical-material-form__field material-form__label'
                        />
                    </MuiPickersUtilsProvider>
                </Col>
                <Col md={3}>
                    <MuiPickersUtilsProvider utils={MomentUtils} >
                        <KeyboardDatePicker
                            style={{ minWidth: '300px', maxWidth: '100%' }}
                            value={finalDate}
                            onChange={(date) => {
                                setFinalDate(date);
                            }}
                            label="Fecha Final"
                            format="DD/MM/YYYY"
                            animateYearScrolling
                            className='medical-material-form__field material-form__label'
                        />
                    </MuiPickersUtilsProvider>
                </Col>
                <Col md={3}>
                    <Button
                        style={{ marginTop: 10, marginRight: 10 }}
                        variant="contained"
                        className="btn btn-primary text-white"
                        onClick={() => {
                            getIndicatorRegistersControl(starterDate, finalDate);
                        }}
                    >
                        Filtrar
                    </Button>
                </Col>
                <Col md={3}>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            style={{ marginTop: 10, marginRight: 10, }}
                            variant="contained"
                            className="btn btn-primary text-white"
                            onClick={() => {
                                setOpenModalCompare(true);
                            }}
                        >
                            Comparar
                        </Button>
                    </div>

                </Col>
            </Row>

            {loading == true ? <Spinner animation="border" variant="success" /> : <div className="tabs tabs--justify tabs--bordered-top">
                <div className="tabs__wrap">
                    <Nav tabs>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === '1' })}
                                onClick={() => toggle('1')}
                            >
                                Rechazo de Estudios
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === '2' })}
                                onClick={() => toggle('2')}
                            >
                                Control de Registros
                            </NavLink>
                        </NavItem>
                    </Nav>

                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="1">
                            {dataIndicatorRejects.length > 0 ?
                                <Row>
                                    <Col md={5}>
                                        <TableMontlhyRejecteds reactTableData={dataIndicatorRejects} yearVisible={false} />
                                    </Col>
                                    <Col md={7}>
                                        <AnimatedBarMontlyRejecteds dataIndicator={dataIndicatorRejects} />
                                        <br />
                                        <CriterialsDescriptions />
                                    </Col>
                                </Row>
                                : null}
                        </TabPane>
                        <TabPane tabId="2">
                            {dataIndicator.length > 0 ?
                                <Row>
                                    <Col md={12}>
                                        <TableRegitersControl reactTableData={dataIndicator} />
                                        <br />
                                        <div>
                                            <Button
                                                style={{ marginTop: 10, marginRight: 10 }}
                                                variant="contained"
                                                className="btn btn-success text-white"
                                                onClick={() => {
                                                    ExportRegistersControlExcel();
                                                }}
                                            >
                                                Exportar a Excel
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                                : null}
                        </TabPane>
                    </TabContent>
                </div>
            </div>}

            <ModalMontlyRejecteds opened={openModalCompare} closeModal={() => { setOpenModalCompare(false) }} />

        </Fragment>
    );
}
export default RegistersControl;